export default __webpack_public_path__ + "1664d20cdaaa6e9a255c691cbd9bab19.png";